import { FC } from 'react';
import styled, { css } from 'styled-components';

const CHIP_DIAMETER = '24px';

interface ChipDisplayProps {
	borderBottomLeftRadius?: string;
	borderBottomRightRadius?: string;
	borderTopLeftRadius?: string;
	borderTopRightRadius?: string;
	withIcon?: boolean;
}

const ChipDisplay = styled.dl<ChipDisplayProps>`
	align-items: center;
	background-color: var(--balance-chip-circle, rgba(var(--base-08), 1));
	display: inline-flex;
	padding: 5px 12px;
	margin: 0;
	border-bottom-left-radius: ${({ borderBottomLeftRadius }) => borderBottomLeftRadius};
	border-bottom-right-radius: ${({ borderBottomRightRadius }) => borderBottomRightRadius};
	border-top-left-radius: ${({ borderTopLeftRadius }) => borderTopLeftRadius};
	border-top-right-radius: ${({ borderTopRightRadius }) => borderTopRightRadius};
	${({ withIcon }) =>
		withIcon &&
		css`
			padding: 2px 0px 2px 12px;
		`};
`;

const ChipText = styled.dd`
	color: var(--balance-chip-text, rgba(var(--base-02), 1));
	font: var(--caption);
	margin: 0;
`;

const ChipIconWrapper = styled.dt`
	align-items: center;
	background-color: var(--balance-icon-chip-wrapper, rgba(var(--base-10), 1));
	display: flex;
	height: ${CHIP_DIAMETER};
	width: ${CHIP_DIAMETER};
	justify-content: center;
	margin: 0 3px 0 12px;
	svg {
		fill: var(--balance-chip-icon, rgba(var(--base-02), 1));
		height: 20px;
		width: 20px;
	}
	border-radius: 50%;
`;

interface Props {
	children?: string;
	dataAt?: string;
	icon?: React.ReactNode;
	iconDataAt?: string;
	borderBottomLeftRadius?: string;
	borderBottomRightRadius?: string;
	borderTopLeftRadius?: string;
	borderTopRightRadius?: string;
}

const Chip: FC<Props> = ({
	borderBottomLeftRadius = '18px',
	borderBottomRightRadius = '18px',
	borderTopLeftRadius = '18px',
	borderTopRightRadius = '18px',
	children = '',
	dataAt = '',
	icon,
	iconDataAt
}) => (
	<ChipDisplay
		borderBottomLeftRadius={borderBottomLeftRadius}
		borderBottomRightRadius={borderBottomRightRadius}
		borderTopLeftRadius={borderTopLeftRadius}
		borderTopRightRadius={borderTopRightRadius}
		withIcon={!!icon}
	>
		<ChipText data-at={dataAt}>{children}</ChipText>
		{icon && <ChipIconWrapper data-at={iconDataAt}>{icon}</ChipIconWrapper>}
	</ChipDisplay>
);

export default Chip;

export { ChipDisplay, ChipText, ChipIconWrapper };
